import useRebrandVersion from 'hooks/useRebrandVersion'
import type { _BaseButtonKind } from 'LuxKit/Button/BaseButton'

function useCarouselArrowKind(): _BaseButtonKind {
  const rebrandVersion = useRebrandVersion()
  return rebrandVersion === 'rebrand' ? 'primary' : 'secondary'
}

export default useCarouselArrowKind
